import React, { Component } from "react";
import { Modal, ModalBody, ModalHeader, Button } from "reactstrap";
import { Formik } from "formik";
import axiosInstance from "../../axios-project";

class SignupModal extends Component {
  render() {
    return (
      <Modal
        id="userModal"
        isOpen={this.props.modal}
        fade
        toggle={this.props.toggle}
        backdrop="static"
      >
        <div className="modal-content">
          <ModalHeader toggle={this.props.toggle}>User</ModalHeader>
          <ModalBody>
            <Formik
              initialValues={this.props.curr_user}
              onSubmit={(values, { setSubmitting }) => {
                this.props.toggle();
                if (!this.props.curr_user) {
                  axiosInstance
                    .post("auth/signup", values)
                    .then(res => {
                      this.props.fetchAdminDetails();
                    })
                    .catch(e => {
                      console.log(e);
                    });
                } else {
                  axiosInstance
                    .put("user/" + this.props.curr_user.id, values)
                    .then(response => {
                      console.log("Success");
                      this.props.fetchAdminDetails();
                    })
                    .catch(error => {
                      console.log(error);
                    });
                }
              }}
            >
              {({
                values,
                handleChange,
                handleSubmit
                /* and other goodies */
              }) => (
                <form onSubmit={handleSubmit}>
                  <small className={"d-block"}>
                    <span style={{ color: "red" }}>*</span> required
                  </small>
                  <div className="form-row">
                    <label className="col-sm-4" htmlFor="name">
                      Name
                    </label>
                    <input
                      type="text"
                      required
                      name="name"
                      maxLength={40}
                      id="name"
                      className="col-sm-6 form-control"
                      onChange={handleChange}
                      value={values.name}
                    />
                  </div>
                  <div className="form-row">
                    <label className="col-sm-4" htmlFor="email">
                      Email
                    </label>
                    <input
                      type="email"
                      name="email"
                      maxLength={40}
                      id="email"
                      className="col-sm-6 form-control"
                      onChange={handleChange}
                      value={values.email}
                    />
                  </div>
                  <div className="form-row">
                    <label className="col-sm-4" htmlFor="username">
                      Username
                    </label>
                    <input
                      type="text"
                      name="username"
                      minLength={3}
                      maxLength={30}
                      id="username"
                      className="col-sm-6 form-control"
                      onChange={handleChange}
                      value={values.username}
                    />
                  </div>
                  <div className="form-row">
                    <label className="col-sm-4" htmlFor="password">
                      Password
                    </label>
                    <input
                      type="password"
                      name="password"
                      maxLength={100}
                      id="password"
                      className="col-sm-6 form-control"
                      onChange={handleChange}
                      value={values.password}
                    />
                  </div>
                  <div className="form-group my-3">
                    <Button
                      color="primary"
                      type="submit"
                      className="float-left mx-2"
                    >
                      Submit
                    </Button>
                    <Button
                      color="secondary"
                      className="float-left"
                      onClick={this.props.toggle}
                    >
                      Cancel
                    </Button>
                  </div>
                </form>
              )}
            </Formik>
          </ModalBody>
        </div>
      </Modal>
    );
  }
}

export default SignupModal;
